import request from '@/utils/util.request';
/**
 * @desc (subtitle) 创建字幕页面加载
 */
export const subtitle_load_data = (data) => {
	return request({
		url: '/subtitle/loaddata',
		data,
	});
};

/**
 * @desc (subtitle) 创建字幕页面创建
 * @param {string} subtitle 字幕 content
 * @param {string} color 字体颜色
 * @param {string} location 显示位置
 * @param {int} speed 滚动速度
 * @param {int} size 字体大小
 * @param {int} haslogo 写死 0
 */
export const subtitle_submit = (data) => {
	return request({
		url: '/subtitle/submit',
		data,
	});
};
